import React from "react";
import { CV } from "../components/cv";
import LyupchoKImg from "@/assets/images/lyupchu-k.png";

export default function CVLyupchoKotev() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Lyupcho Kotev";
  }, []);

  return (
    <CV
      name="Lyupcho Kotev"
      title="Developer · Platform Engineer"
      subtitle="Platform engineering, CI/CD and developer experience — 8+ years at IKEA and Shell"
      photo={LyupchoKImg}
      summary="Passionate Developer and DevOps Engineer with an interest in Platform Engineering, eager improving developer effectiveness and experience in organisations. Focused on automation, infrastructure, and enabling development teams."
      skills={{
        "Languages": ["Go", "Python", "JavaScript"],
        "Platform": ["Platform Engineering", "Backstage", "DevOps", "CI/CD", "Developer Experience"],
        "Infrastructure": ["Kubernetes", "OpenShift", "Docker", "Docker Swarm", "AWS", "Azure", "Linux"],
        "Tools": ["Jenkins", "Elastic Stack", "VueJS", "Flask", "CKAN", "MongoDB"],
        "Methods": ["Microservices", "Automation", "Monitoring"],
      }}
      experience={[
        {
          role: "Technical Lead",
          company: "IKEA",
          period: "Aug 2023 – Present",
          description:
            "Technical lead for platform engineering, driving developer effectiveness and experience across IKEA's engineering organisation.",
          highlights: [
            "Tech: Backstage, Platform Engineering, Kubernetes, Go, Azure",
          ],
        },
        {
          role: "Senior Software Engineer (Consultant)",
          company: "IKEA",
          period: "Jan 2020 – Aug 2023",
          description:
            "Senior consultant working on platform and developer tooling within IKEA's engineering teams.",
          highlights: [
            "Tech: Go, Kubernetes, Docker, OpenShift, Jenkins",
          ],
        },
        {
          role: "DevOps Engineer (Consultant)",
          company: "IKEA",
          period: "Feb 2018 – May 2023",
          description:
            "Developed a custom CI/CD framework and workflow for IKEA using Jenkins, Docker and OpenShift Container Platform.",
          highlights: [
            "Dynamically provisioned Jenkins slaves using OpenShift",
            "Developed custom shared library for Jenkins to standardize CI/CD processes",
            "Built an API in Go for creating testing environments on OpenShift, used by Jenkins for integration tests and QA",
            "Created a custom dashboard in VueJS for teams to view CI/CD pipelines and manage testing environments",
            "Set up Elastic Stack for measuring team performance",
          ],
        },
        {
          role: "Founder",
          company: "Codira AB",
          period: "Jan 2023 – Present",
          description:
            "Consulting services through own firm, focused on platform engineering and DevOps.",
        },
        {
          role: "Software Developer / DevOps",
          company: "Keitaro",
          period: "Feb 2018 – May 2023",
          description:
            "Software development and DevOps consulting, including full-stack implementation of open-data portals powered by CKAN.",
          highlights: [
            "Developed and integrated custom CKAN extensions",
            "Custom integrations with external systems for data synchronization",
            "Implemented single-sign-on extension for CKAN using CAS protocol",
          ],
        },
        {
          role: "Software Developer",
          company: "Keitaro",
          period: "Aug 2016 – Feb 2018",
          description:
            "Full-stack development of open-data portals and third-party integrations.",
        },
        {
          role: "Software Developer / DevOps (Consultant)",
          company: "Shell",
          period: "Sep 2016 – Dec 2017",
          description:
            "Data publishing and synchronization platform for seismic data using microservices architecture.",
          highlights: [
            "Set up and managed Docker Swarm (EE) cluster and Docker Trusted Registry in AWS",
            "CI/CD pipelines using Jenkins and VSTS for staging/production",
            "Deployed OpenAPI APIs on AWS API Gateway with Cognito and Duo for auth",
            "Tech: Azure Cosmos, Service Bus, Flask, MongoDB, Docker, Jenkins",
          ],
        },
        {
          role: "Intern",
          company: "iborn.net",
          period: "Feb 2016",
          description:
            "Worked on an eCommerce website with PrestaShop and data parsing with regular expressions.",
        },
      ]}
      education={[
        {
          degree: "Computer Science and Engineering",
          institution: "Faculty of Computer Science and Engineering, Skopje, Macedonia",
          year: "2012 – 2017",
        },
      ]}
    />
  );
}
